/**
 * Refactored Actions into ./Actions.
 * Add new actions there.
 */
import Actions from "./Actions";

export default {
	...Actions,
};
